import axios from 'axios';
import { BaseURL, ORGID } from '../constant'

export const registerUserForOtp = (firstname,lastname, mobileNumber) => {
    return new Promise((resolve, reject) => {
        axios.post(`${BaseURL}/api/ril/cw/${ORGID}/users/external_users`, {
            "first_name": firstname,
            "last_name": lastname,
            "mobile": `+91${mobileNumber}`,
            "email": ""
        }, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((res) => {
                sendOtp(mobileNumber)
                .then((data) => resolve(data))
                .catch(reject);
            })
            .catch((err) => {
                if (err.response.data.message === "User with this email id or phone number already exists") {
                    sendOtp(mobileNumber)
                    .then((data) => resolve(data))
                    .catch(reject);
                } else {
                    reject(err);
                }
            });
    })
}

export const sendOtp = (mobileNumber) => {
    return new Promise((resolve, reject) => {
            axios.post(`${BaseURL}/api/ril/cw/${ORGID}/users/external_users/otp`, {
            "mobile": `+91${mobileNumber}`,
            "email": ""
        }, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((data) => resolve(data))
            .catch(reject);
    })
}

export const verifyOtp = (mobileNumber, otp) => {
    return new Promise((resolve, reject) => {
        axios.post(`${BaseURL}/api/ril/cw/${ORGID}/users/external_users/login`, {
            "mobile": `+91${mobileNumber}`,
            "password": otp
        },{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then((data) => resolve(data))
        .catch(reject);
    })
}

export const registerUser = (userData) => {
    return new Promise((resolve, reject) => {
        axios.post(`${BaseURL}/api/ril/reliance-skilling-recommendation/v1/user_registration`, userData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then((response) => {
          console.log('Received response:', response.data);
            resolve(response.data);
        })
        .catch(reject);
    });
};